import { createEntityAdapter } from '@reduxjs/toolkit'

import { PlanningStop } from '../models/planning/PlanningStop'

export const planningStopsAdapter = createEntityAdapter({
  selectId: (stop: PlanningStop) => stop.id,
})
